import React from 'react';
import { LETS_TALK_IMAGE } from '../../Utils/siteConfig';

const LetsTalkPhoneImage = () => (
  <div className="contact-right-img contact-split-layout__photo">
    <img
      src={LETS_TALK_IMAGE}
      alt="Al Dawood Holding Group reception, Al Khobar"
      className="contact-side-photo"
    />
  </div>
);

export default LetsTalkPhoneImage;
